/**
 * Take a number of minutes and adds it to a date, returning a new date.
 *
 * @param date - The date to add the minutes to.
 * @param minutes - The number of minutes to add. Can be above 60.
 * @returns A new date with the minutes added.
 */
export const addDateAndTime = (date: Date, minutes: number): Date => {
  const newDate = new Date(date);
  newDate.setMinutes(minutes % 60);
  const hours = Math.floor(minutes / 60);
  newDate.setHours(hours);
  return newDate;
};
